export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-28-O-Nav-WEB-b65845f364d1a39ee7f93baa87b6f5db.png";